module.exports = __webpack_public_path__ + "media/images/icon__dropdown--arrow-80040c15bd5154950c01970e36c029a6.png";